import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import { PiStudentBold } from "react-icons/pi";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { PiBankBold } from "react-icons/pi";
import { LuHandshake } from "react-icons/lu";
import { TbMichelinStarGreen } from "react-icons/tb";
import FonColor from '../../img/fon-color.jpg';

function AfterLearning() {

    let learningArray = [
        {
            icon: <PiStudentBold className="text-4xl mx-auto text-white" />,
            title: 'Цифрові навички',
            description: 'Дізнаєшся, як опанувати затребувані онлайн-професії дизайн, програмування, маркетинг, AI-контент, e-commerce тощо через зручні платформи й підтримку менторів.',
        },
        {
            icon: <LuBriefcaseBusiness className="text-4xl mx-auto text-white" />,
            title: 'Роуд-меп побудови онлайн-бізнесу, бо все навколо переходить в онлайн',
            description: 'Навчишся створювати продукти, послуги, програми навчання, просувати себе в соцмережах і автоматизувати процеси.',
        },
        {
            icon: <PiBankBold className="text-4xl mx-auto text-white" />,
            title: 'Доступ до грантів',
            description: 'Отримаєш шаблони, поради експертів і підтримку в подачі заявок за програмами, де у фокусі саме жінки, що починають свою справу.',
        },
        {
            icon: <LuHandshake className="text-4xl mx-auto text-white" />,
            title: 'Сильне жіноче ком’юніті',
            description: 'Спілкування з менторками, розвиток лідерського мислення та спілкування у ком’юніті без стереотипів, підтримка психологічних коучів.',
        }
    ]
    return (
        <section className="relative overflow-hidden">
            <div className="container max-w-screen-xl sm:p-20 px-5 max-sm:py-8 w-[90%] mx-auto relative z-20 mb-[60px]" style={{background: 'url('+ FonColor +')',backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}}>
                <div className="max-w-screen-lg mx-auto">
                    <ScrollAnimation animateIn="animate__fadeInUp">
                        <h2 className="sm:text-4xl text-2xl mb-10 uppercase title-design before:bg-[#C86FFF]/30 after:bg-[#C86FFF]/30"><span>ТВІЙ РЕЗУЛЬТАТ ПІСЛЯ ПРОГРАМИ</span></h2>
                        {/*<p className="w-full max-w-screen-md mb-5">Ти отримуєш менше теорії — більше дій! У 2026 році Women in Tech стала ще практичнішою та ефективнішою.</p>*/}
                    </ScrollAnimation>
                    <div className="grid sm:grid-cols-2 gap-4 mb-5">
                        {
                            learningArray ? learningArray.map((learning, item) => (
                                <div key={item}>
                                    <ScrollAnimation animateIn="animate__fadeInUp"
                                        className="flex flex-wrap mb-2 relative overflow-hidden items-center justify-between">
                                        <div className="relative overflow-hidden w-[80px] py-3 bg-[#C86FFF] h-full">
                                            {learning.icon}
                                        </div>
                                        <h3 className="text-xl w-[calc(100%-115px)] relative">{learning.title}</h3>
                                        <div
                                            className="absolute -bottom-2 left-10 w-full h-[10px] bg-[#C86FFF] transform-gpu skew-x-[30deg] z-10"/>
                                    </ScrollAnimation>
                                    <ScrollAnimation animateIn="animate__fadeInUp">{learning.description}</ScrollAnimation>

                                </div>
                            )) : ''
                        }
                    </div>
                    {/*<ScrollAnimation animateIn="animate__fadeInUp" className="flex w-full max-w-screen-md">
                        <TbMichelinStarGreen className="text-6xl mr-[15px]"/>
                        <div className="font-bold">
                            <p>Інтеграція теми зеленої енергетики, кібербезпеки, роботи в умовах війни, гендерної
                                рівності в
                                онлайні</p>
                        </div>

                    </ScrollAnimation>*/}
                </div>
            </div>
        </section>
        
    )
}

export default AfterLearning